import { defaultFilterValues, toFilterQuery } from '@/utils/listQuery'

// Shared filters, server-side sort and pagination for list pages. The state is kept per table in the
// store, so returning from a form (save or cancel) restores the same filters, sort, page and page size.
// The component must define `tableKey`, `filterFields`, `page`, `size` and `totalPages` in data,
// and a `fetchItems()` method.
export default {
    data: () => {
        return {
            filterValues: {},
            sort: { sortBy: null, sortDesc: false }
        }
    },
    computed: {
        filterQuery() {
            return toFilterQuery(this.filterFields, this.filterValues)
        }
    },
    watch: {
        totalPages(total) {
            // e.g. the edited/deleted item was the only one on the last page, or no longer matches the filters
            if (total > 0 && this.page > total) {
                this.paginationChange(total, this.size)
            }
        }
    },
    created() {
        const saved = this.$store.getters.getTableState(this.tableKey)
        if (saved) {
            this.filterValues = saved.filterValues
            this.sort = saved.sort
            this.page = saved.page
            this.size = saved.size
        } else {
            this.filterValues = defaultFilterValues(this.filterFields)
        }
    },
    methods: {
        paginationChange(page, size) {
            this.page = page
            this.size = size
            this.saveTableState()
            this.fetchItems()
        },
        applyFilters(values) {
            this.filterValues = values
            this.paginationChange(1, this.size)
        },
        changeSort(sort) {
            this.sort = sort
            this.paginationChange(1, this.size)
        },
        saveTableState() {
            this.$store.dispatch('setTableState', {
                table: this.tableKey,
                value: { filterValues: this.filterValues, sort: this.sort, page: this.page, size: this.size }
            })
        }
    }
}
